import { send } from '@actual-app/core/platform/client/connection';
import type { AccountBalanceEntity } from '@actual-app/core/types/models';
import { queryOptions } from '@tanstack/react-query';

export const accountBalanceQueries = {
  all: () => ['account-balances'],
  lists: () => [...accountBalanceQueries.all(), 'lists'],
  list: () =>
    queryOptions<AccountBalanceEntity[]>({
      queryKey: [...accountBalanceQueries.lists()],
      queryFn: async () => {
        const balances: AccountBalanceEntity[] = await send(
          'account-balances-get',
        );
        return balances;
      },
      placeholderData: [],
      // Written by whatever sidecar polls Enable Banking's balances
      // endpoint (see wailmu/actual#20), replicated through the same CRDT
      // sync as any other write and invalidated on the resulting
      // `account_balances` sync-event (see sync-events.ts's
      // `listenForSyncEvent`, same pattern as exchangeRateQueries). The
      // periodic refetch here is just a fallback in case that invalidation
      // is ever missed, not the primary mechanism -- so 5 minutes of slack
      // is fine.
      staleTime: 5 * 60 * 1000,
      refetchInterval: 5 * 60 * 1000,
    }),
};
